
import { DtoComunAplicacionesmast } from './../../../../framework-comun/seguridad/dominio/dto/DtoComunAplicacionesmast';
import { Injectable } from '@angular/core';
import { AppConfig } from '@env/appconfig';
import { JWT_RESPONSE_HEADER } from './../../../constantes';
import { DtoTabla } from 'src/app/royal/framework/modelo/generico/dto/DtoTabla';
import { SeguridadUsuarioLogin } from 'src/app/royal/framework/modelo/seguridad/SeguridadUsuarioLogin';
import { SeguridadUsuarioActual } from 'src/app/royal/framework/modelo/seguridad/SeguridadUsuarioActual';
import { DominioMensajeUsuario } from '@framework/modelo/generico/DominioMensajeUsuario';

@Injectable()
export class UsuarioService {
    private url2 = `${this.config.getEnv('spring-framework-comun-api')}spring/seguridad/aplicacionesmastcomun/`;
    private url3 = `${this.config.getEnv('spring-framework-comun-api')}spring/core/tipocambiomast/`;
    private url = `${this.config.getEnv('spring-framework-seguridad-api')}autorizacion/seguridad/login/`;
    private urlmenu = `${this.config.getEnv('spring-framework-seguridad-api')}spring/seguridad/usuario/`;
    constructor(private config: AppConfig) {
    }

    public obtenerMenu(): Promise<any> {
        return this.config.getHttp().get(`${this.url}obtenermenu`)
            .toPromise()
            .then(response => response as any)
            .catch(error => new Object());
    }

    public wf_getmodules(): Promise<any> {
        return this.config.getHttp().get(`${this.urlmenu}wf_getmodules`)
            .toPromise()
            .then(response => response as any)
            .catch(error => new Object());
    }

    public obtenerUsuarioActual(): Promise<SeguridadUsuarioActual> {
        return this.config.getHttp().get(`${this.urlmenu}obtenerusuarioactual`)
            .toPromise()
            .then(response => response as SeguridadUsuarioActual
            )
            .catch(error => new SeguridadUsuarioActual());
    }

    public cambiarClaveUsuario(usuario: any): Promise<DtoTabla> {

        return this.config.getHttp().put(this.url + 'cambiarClaveUsuario', usuario)        
            .toPromise()
            .then(response => this.saveToken(response as SeguridadUsuarioLogin)
            )
            .catch(error => null);
    }


    public validarClave(usuario: any): Promise<DominioMensajeUsuario[]> {

        return this.config.getHttp().put(this.url + 'validarClave', usuario)        
            .toPromise()
            .then(response => response as DominioMensajeUsuario[])
            .catch(error => []);
    }

    private saveToken(res: SeguridadUsuarioLogin): any {
        const token = res.token;
        if (token) {
            localStorage.setItem(JWT_RESPONSE_HEADER, token);
        }
        return res;
    }


    public auxPeriodoobtenerDto(aplicacioncodigo: string): Promise<DtoComunAplicacionesmast> {
        var filtro = new DtoComunAplicacionesmast();
        filtro.aplicacioncodigo=aplicacioncodigo;
        return this.config.getHttp().put(this.url2 + 'obtenerdto', filtro)
            .toPromise()
            .then(response => response as DtoComunAplicacionesmast)
            .catch(error => new DtoComunAplicacionesmast());
    } 

    public auxObtenerTipoCambioCreacionDefault(): Promise<any> {
        return this.config.getHttp().get(this.url3 + 'obtenerTipoCambioCreacionDefault')
            .toPromise()
            .then(response => response as any)
            .catch(error => null);
    }


}